<template>
  <div class="py-0 col col-12">
    <v-col cols="12" class="py-0 d-flex justify-end">
      <div
        class="d-flex pa-0 ma-0 mr-2 align-center"
        :style="{
          'max-width': MobileSize ? '75%' : '60%',
        }"
      >
        <v-card
          class="d-flex mb-2 justify-end align-center"
          flat
          tile
          color="transparent"
        >
          <v-card class="rounded" color="transparent" flat tile>
            <v-card
              class="pa-2 black--text rounded-xl"
              color="grey lighten-2"
              :style="{
                'white-space': 'pre-line',
              }"
              >{{ message.text }}</v-card
            >
          </v-card>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" :disabled="!Editing" v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-card
              :height="LastQuestion.type !== 'quickReply' ? 200 : undefined"
              width="250"
            >
              <v-list>
                <v-list-item @click="editquickreply = true">
                  <v-list-item-title>แก้ไข</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$delete(QuestionList, index)">
                  <v-list-item-title>ลบ</v-list-item-title>
                </v-list-item>
                <div v-if="LastQuestion.type !== 'quickReply'">
                  <v-divider></v-divider>
                  <v-subheader>สลับคำถาม</v-subheader>
                  <v-list-item
                    v-for="(item, i) in QuestionList"
                    @click="movequestion(i)"
                    :key="i"
                  >
                    <v-list-item-title>{{
                      item.type === "image"
                        ? `รูปภาพที่ ${i + 1}`
                        : item.type === "video"
                        ? `วิดีโอที่ ${i + 1}`
                        : item.text
                    }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list>
            </v-card>
          </v-menu>
          <EditButtongroup
            :visible="editquickreply"
            :message="message"
            @close="editquickreply = false"
          />
        </v-card>
      </div>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-card :class="`d-flex justify-end mb-1`" color="transparent" flat tile>
        <v-chip-group column>
          <v-chip
            v-for="button in message.buttons"
            :key="button.text"
            @click="AddtoFixtext(button)"
          >
            {{ button.text }}
          </v-chip>
        </v-chip-group>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import EditButtongroup from "./EditButtongroup";
export default {
  props: ["message", "Editing", "index", "QuestionList", "LastQuestion"],
  components: { EditButtongroup },
  data() {
    return {
      editquickreply: false,
    };
  },
  methods: {
    AddtoFixtext(button) {
      if (button.type === "text") {
        if (this.Editing) {
          this.$store.state.texttoadd.text = button.text;
        }
      }
    },
    movequestion(indexmove) {
      let index = this.index;
      let moveindex = indexmove;
      let old_index = index;
      let new_index = moveindex;
      if (new_index >= this.QuestionList.length) {
        var k = new_index - this.QuestionList.length + 1;
        while (k--) {
          this.QuestionList.push(undefined);
        }
      }
      this.QuestionList.splice(
        new_index,
        0,
        this.QuestionList.splice(old_index, 1)[0]
      );
    },
  },
  computed: {
    MobileSize() {
      const { xs } = this.$vuetify.breakpoint;
      return xs ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>